import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ReshapeEllipseAction extends AbstractProvidedClass {
    constructor(provider, elementPart) {
        super(provider);

        this.elementPart = elementPart;
        this.parent = elementPart.parent;
        this.oldSize = this.parent.size;
    }

    update() {
        this.elementPart.move();
    }

    finish() {
        this.newSize = this.parent.size;
        this.oldSize == this.newSize
            ? this.actions.discard()
            : this.actions.finish();
    }

    undo() {
        this.parent.size = this.oldSize;
        this.getTab('info').input.size.value(this.calculatePixelToDisplayDistance(this.parent.size));
    }

    redo() {
        this.parent.size = this.newSize;
        this.getTab('info').input.size.value(this.calculatePixelToDisplayDistance(this.parent.size));
    }
}
